import { render, staticRenderFns } from "./refundExpressForm.vue?vue&type=template&id=255eeb92&"
import script from "./refundExpressForm.vue?vue&type=script&lang=js&"
export * from "./refundExpressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports